import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../../store/campanha';

//COMPONENTS
import {Modal, Row, Column} from '../inspinia'

class ModalSaibaMais extends React.Component
{
    constructor(props)
    {
        super(props);

        this.handleVoltarClick = this.handleVoltarClick.bind(this);
        this.handleNovaClick   = this.handleNovaClick.bind(this);
    }

    handleVoltarClick()
    {
        this.props.actions.campanha.finalizar().then(() => 
        {
            this.props.history.push(c.DEFAULT_PRIVATE_ROUTE);
        });
    }

    handleNovaClick()
    {
        this.props.actions.campanha.finalizar().then(() => 
        {
            this.props.history.push(c.CAMPAIGN_ROUTE+"/criar");
        });
    }

    render()
    {
        return (                       
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>              
                                    
                <h3 style={{color:'#006666'}}>Tipos de Envio</h3>

                <p className="fs-16 fw-300 text-body">
                    <h5>Conheça sobre os tipos de envio disponíveis da plataforma.</h5>
                </p>

                <Row className="my-0 text-left">
                    <Column size="4">
                        <Row className="mb-2">
                            <Column>
                                <img src="assets/images/006-search.svg" />
                            </Column>
                        </Row>

                        <Row className="mb-2">
                            <Column>
                                <span>Rastreado</span>
                            </Column>
                        </Row>
                    </Column>
                    <Column size="8">
                        <Row className="mb-0">
                            <Column>
                                <span>Realiza o disparo do e-mail e rastreia todo fluxo de envio.</span>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </Modal>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, campanha: state.campanha };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModalSaibaMais));
